import { createFileRoute } from '@tanstack/react-router';
import { basicHead } from '../../utility/head';
import { FeatureArticle, featureSeo } from '../../components/FeatureArticle';
import { connectMultipleSources } from '../../assets/data/features/connect-multiple-sources';

export const Route = createFileRoute('/_marketing/connect-multiple-sources')({
  component: () => <FeatureArticle data={connectMultipleSources} />,
  ssr: true,
  loader: ({ location }) => ({
    pathname: location.pathname,
    seo: featureSeo(connectMultipleSources),
  }),
  head: basicHead,
});
